<template>
    <div class="t-lk-price">
        <div class="t-lk-container">
            <template v-if="isMobile">
                <div v-animation:bottom.delay class="t-lk-promotions__row t-lk-container-mobile">
                    <h1 class="t-lk-title t-lk-promotions__title">{{ $root.staticText.lk.priceTitle }}</h1>
                    <router-link to="/lk/price-lists/favorites" class="t-btn-green">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 1.2002C12.3047 1.2002 12.5828 1.37305 12.7176 1.6461L15.6216 7.52937L22.1159 8.47861C22.4172 8.52264 22.6673 8.73384 22.7612 9.02345C22.8551 9.31306 22.7765 9.63086 22.5584 9.84328L17.8598 14.4197L18.9687 20.885C19.0202 21.1851 18.8968 21.4885 18.6504 21.6674C18.404 21.8464 18.0774 21.87 17.8079 21.7283L12.0002 18.6741L6.19258 21.7283C5.92305 21.87 5.59641 21.8464 5.35003 21.6674C5.10365 21.4885 4.98025 21.1851 5.03173 20.885L6.1406 14.4197L1.44203 9.84328C1.22394 9.63086 1.14532 9.31306 1.23922 9.02345C1.33312 8.73384 1.58327 8.52264 1.88452 8.47861L8.37881 7.52937L11.2829 1.6461C11.4176 1.37305 11.6957 1.2002 12.0002 1.2002ZM12.0002 3.8076L9.62758 8.6143C9.51115 8.85017 9.2862 9.01374 9.02592 9.05179L3.71895 9.82748L7.5584 13.5671C7.7471 13.7509 7.83323 14.0158 7.78871 14.2754L6.88276 19.5575L11.6279 17.0621C11.861 16.9396 12.1395 16.9396 12.3726 17.0621L17.1177 19.5575L16.2117 14.2754C16.1672 14.0158 16.2533 13.7509 16.442 13.5671L20.2815 9.82748L14.9745 9.05179C14.7142 9.01374 14.4893 8.85017 14.3729 8.6143L12.0002 3.8076Z" fill="#00b0bd"/>
                        </svg>
                    </router-link>
                </div>
            </template>
            <lk-title-link-cmp
                v-else
                v-animation:bottom.delay
                :title="$root.staticText.lk.priceTitle"
                :link="'/lk/price-lists/favorites'"
                :name="$root.staticText.lk.priceTitleFavorites"
            ></lk-title-link-cmp>

            <div v-animation:bottom.delay class="t-lk-promotions-completed t-lk-requests__container">
                <div v-animation:bottom.delay class="t-lk-promotions-completed__row t-lk-price__container">
                    <filter-search-cmp
                        class="t-lk-filter__search"
                        :is-lk="true"
                        action="lk/price-lists/searchItems"
                    >
                    </filter-search-cmp>
                    <lk-date-cmp
                        :obj-undefined="{currentPage: undefined}"
                    >
                    </lk-date-cmp>
<!--                    <filter-cmp-->
<!--                        v-if="filter"-->
<!--                        class="t-lk-price__filter"-->
<!--                        :filter="filter"-->
<!--                        :obj-undefined="{currentPage: undefined}"-->
<!--                        :name-btn="$root.staticText.lk.priceFilterBtn"-->
<!--                        :is-date="true"-->
<!--                        :is-date-left="false"-->
<!--                    >-->
<!--                    </filter-cmp>-->

                </div>
                <div class="t-lk-promotions-completed-table">
                    <div v-animation:bottom.delay class="t-lk-promotions-completed-table__row _first">
                        <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td">
                            <router-link
                                :to="{name: $route.name, query: {
                                ...$route.query,
                                sort: $route.query.sort === '-vendor' ? 'vendor' : '-vendor'
                            }}"
                                class="t-lk-price__link"
                                :class="{_active: $route.query.sort && $route.query.sort.includes('vendor')}"
                            >
                                {{ $root.staticText.lk.priceTable }}
                            </router-link>
                        </div>
                        <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td">
                            {{ $root.staticText.lk.priceTable2 }}
                        </div>
                        <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td">
                            <router-link
                                :to="{name: $route.name, query: {
                                ...$route.query,
                                sort: $route.query.sort === 'date' ? '-date' : 'date'
                            }}"
                                class="t-lk-price__link"
                                :class="{_active: $route.query.sort && $route.query.sort.includes('date')}"
                            >
                                {{ $root.staticText.lk.priceTable3 }}
                            </router-link>
                        </div>
                        <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td">
                            {{ $root.staticText.lk.priceTable4 }}
                        </div>
                    </div>
                    <div class="js-price-lists">
                        <div
                            v-animation:bottom.delay
                            v-for="(item, index) in priceLists"
                            :key="'priceLists' + priceLists.length + item.id"
                            class="t-lk-promotions-completed-table__row t-lk-price__table"
                            :style="{'z-index': priceLists.length - index}"
                            :class="{_bold: item.isToday}"
                        >
                            <div class="t-lk-promotions-completed-table__td t-lk-requests__td">
                                <div class="t-lk-price__text">{{ item.name }}</div>
                            </div>
                            <div class="t-lk-promotions-completed-table__td ">
                                <div class="t-lk-price__text">{{ item.size }}</div>
                            </div>
                            <div class="t-lk-promotions-completed-table__td ">
                                <div class="t-lk-price__text">{{ item.date }}</div>
                            </div>
                            <div class="t-lk-promotions-completed-table__td t-lk-price__row">
                                <div class="t-lk-price-promotions js-mobile-cart" @click="mobileOpenCart($event, index)">
                                    <div class="t-lk-price-promotions__head">{{ item.countPromotions }}</div>
                                    <div v-if="!isMobile" class="t-lk-price-promotions__container">
                                        <div class="t-lk-price-promotions__wrap">
                                            <div class="t-lk-price-promotions__item" v-for="list in item.listHint">
                                                {{ list }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="t-lk-price__svg t-lk-price__favorites"
                                    :class="{_active: item.isFavorites}"
                                    @click="toggleFavorite(item)"
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.2002C12.3045 1.2002 12.5826 1.37305 12.7173 1.6461L15.6214 7.52937L22.1157 8.47861C22.4169 8.52264 22.6671 8.73384 22.761 9.02345C22.8549 9.31306 22.7763 9.63086 22.5582 9.84328L17.8596 14.4197L18.9685 20.885C19.0199 21.1851 18.8965 21.4885 18.6502 21.6674C18.4038 21.8464 18.0771 21.87 17.8076 21.7283L12 18.6741L6.19234 21.7283C5.9228 21.87 5.59617 21.8464 5.34979 21.6674C5.1034 21.4885 4.98001 21.1851 5.03149 20.885L6.14036 14.4197L1.44179 9.84328C1.22369 9.63086 1.14508 9.31306 1.23898 9.02345C1.33288 8.73384 1.58302 8.52264 1.88427 8.47861L8.37856 7.52937L11.2826 1.6461C11.4174 1.37305 11.6955 1.2002 12 1.2002Z" fill="#00b0bd"/>
                                    </svg>
                                </div>
                                <a :href="item.download" class="t-lk-price__svg t-lk-price__download">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.99995 14.2002C3.44178 14.2002 3.79995 14.5584 3.79995 15.0002V19.0002C3.79995 19.3185 3.92638 19.6237 4.15142 19.8487C4.37647 20.0738 4.68169 20.2002 4.99995 20.2002H19C19.3182 20.2002 19.6234 20.0738 19.8485 19.8487C20.0735 19.6237 20.2 19.3185 20.2 19.0002V15.0002C20.2 14.5584 20.5581 14.2002 21 14.2002C21.4418 14.2002 21.7999 14.5584 21.7999 15.0002V19.0002C21.7999 19.7428 21.5049 20.455 20.9798 20.9801C20.4547 21.5052 19.7426 21.8002 19 21.8002H4.99995C4.25734 21.8002 3.54515 21.5052 3.02005 20.9801C2.49495 20.455 2.19995 19.7428 2.19995 19.0002V15.0002C2.19995 14.5584 2.55812 14.2002 2.99995 14.2002Z" fill="#00b0bd"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.43427 9.43451C6.74669 9.12209 7.25322 9.12209 7.56564 9.43451L12 13.8688L16.4343 9.43451C16.7467 9.12209 17.2532 9.12209 17.5656 9.43451C17.8781 9.74693 17.8781 10.2535 17.5656 10.5659L12.5656 15.5659C12.2532 15.8783 11.7467 15.8783 11.4343 15.5659L6.43427 10.5659C6.12185 10.2535 6.12185 9.74693 6.43427 9.43451Z" fill="#00b0bd"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.2002C12.4418 2.2002 12.8 2.55837 12.8 3.0002V15.0002C12.8 15.442 12.4418 15.8002 12 15.8002C11.5581 15.8002 11.2 15.442 11.2 15.0002V3.0002C11.2 2.55837 11.5581 2.2002 12 2.2002Z" fill="#00b0bd"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="isMobile"
                class="t-lk-price-promotions__container js-mobile-cart"
                :class="{_open: openMobileCart !== -1}"
                :style="{top: tpy + 'px', left: lpx + 'px'}"
                ref="mobileCart"
            >
                <div class="t-lk-price-promotions__wrap">
                    <template v-for="(item, index) in priceLists">
                        <div
                            v-if="openMobileCart === index"
                            class="t-lk-price-promotions__item"
                            v-for="list in item.listHint"
                        >
                            {{ list }}
                        </div>
                    </template>
                </div>
            </div>

            <pagination-cmp
                v-animation:bottom.delay
                v-if="pagination"
                :pagination="pagination"
                :name-current-page="'currentPage'"
                class="t-lk-requests__pag _lk"
            >
            </pagination-cmp>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import titleLink from '@components/lk/lk-title-link/lk-title-link.vue';
    // import filter from '@components/lk/lk-filter/lk-filter.vue';
    import lkSearch from '@components/ui-components/filter-search/filter-search.vue';
    import lkDate from '@components/lk/lk-date/lk-date.vue';
    import pagination from '@components/ui-components/pagination/pagination.vue';
    import onScrollAnimate from '@assets/js/scrollAnimate.js';
    import { mapState } from "vuex";

    export default {
        name: "lk-price-lists",
        data() {
            return {
                // filter: null,
                priceLists: [],
                pagination: null,
                openMobileCart: -1,
                tpy: null,
                lpx: null,
            }
        },
        components: {
            'lk-title-link-cmp': titleLink,
            // 'filter-cmp': filter,
            'filter-search-cmp': lkSearch,
            'lk-date-cmp': lkDate,
            'pagination-cmp': pagination,
        },
        computed: {
            ...mapState('mobile', ['isMobile', 'isTablet']),
        },
        methods: {
            setData(data) {
                // this.filter = data.filter;
                this.priceLists = data.priceLists;
                this.pagination = data.pagination;
            },
            toggleFavorite(item) {
                let url = 'lk/addFavorite';

                if (item.isFavorites) {
                    url = 'lk/removeFavorite';
                }

                let fd = new FormData();
                fd.append('id', item.id);

                Vue.http.post(url, fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            item.isFavorites = !item.isFavorites;
                        }
                    })
                    .catch(() => {});
            },
            mobileOpenCart(e, index) {
                if (this.isMobile) {
                    this.openMobileCart = index;

                    setTimeout(() => {
                        this.lpx = Math.min(e.pageX, window.innerWidth - this.$refs.mobileCart.clientWidth);
                        this.tpy = e.pageY;
                    }, 10);
                }
            },
        },
        mounted() {
            let _this = this;

            if (this.isMobile) {
                document.addEventListener('click', function (e) {
                    let cart = document.querySelector('.js-mobile-cart');
                    if (cart !== null) {
                        let target = e.target;
                        let its_cart = target === cart || cart.contains(target);
                        if (!its_cart && _this.openMobileCart !== -1) {
                            _this.openMobileCart = -1;
                        }
                    }
                });

                document.addEventListener('touchstart', function (e) {
                    _this.openMobileCart = -1;
                });
            }
        },
        beforeRouteUpdate(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'lk/priceListsPage.json' : 'lk/price-lists';

            this.$root.setDataAnimateFalse('.js-price-lists ');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    this.setData(data.data);
                    next();
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 500);
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'lk/priceListsPage.json' : 'lk/price-lists';
            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/price-lists/index.vue